export const selectCurrentUser = state => state.user.user;
export const selectCountUser = state => state.user.countUser;
export const selectIsLoading = state => state.user.isLoading;
export const selectIsError = state => state.user.IsError;
